import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramInteractionPosts.graphql';
import { Query, QueryinstagramInteractionPostsArgs } from '../../__generated__/globalTypes';

export const useInstagramInteractionPostsQuery = (
  options?: QueryHookOptions<Query, QueryinstagramInteractionPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramInteractionPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramInteractionPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramInteractionPostsArgs>
): QueryResult<Query, QueryinstagramInteractionPostsArgs> & {
  getInstagramInteractionPosts: LazyQueryExecFunction<Query, QueryinstagramInteractionPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramInteractionPosts, result] = useLazyQuery<Query, QueryinstagramInteractionPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInstagramInteractionPosts, ...result };
};

export const useInstagramInteractionPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramInteractionPosts = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramInteractionPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramInteractionPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramInteractionPosts };
};
// Suspense Query Hooks
export const useInstagramInteractionPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramInteractionPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramInteractionPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
